// PawandLuna chat widget UI - floating bubble bottom-right
(function () {
  "use strict";

  var CSS = "\
#plb-bubble{position:fixed;bottom:24px;right:24px;width:60px;height:60px;border-radius:50%;background:#B08D57;color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.25);z-index:999999;transition:transform .2s;border:none}\
#plb-bubble:hover{transform:scale(1.06)}\
#plb-bubble svg{width:28px;height:28px}\
#plb-window{position:fixed;bottom:96px;right:24px;width:360px;max-width:92vw;height:480px;max-height:70vh;background:#fff;border-radius:16px;box-shadow:0 8px 32px rgba(0,0,0,.28);display:none;flex-direction:column;overflow:hidden;z-index:999999;font-family:inherit}\
#plb-window.plb-open{display:flex}\
#plb-header{background:#B08D57;color:#fff;padding:16px;display:flex;align-items:center;justify-content:space-between}\
#plb-header-title{font-weight:600;font-size:15px}\
#plb-header-sub{font-size:12px;opacity:.85;margin-top:2px}\
#plb-close{background:none;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1;padding:4px}\
#plb-messages{flex:1;overflow-y:auto;padding:14px;background:#FAF7F2;display:flex;flex-direction:column;gap:10px}\
.plb-msg{max-width:82%;padding:10px 13px;border-radius:14px;font-size:14px;line-height:1.4}\
.plb-bot{background:#fff;border:1px solid #EDE6D9;align-self:flex-start;border-bottom-left-radius:4px;color:#2b2b2b}\
.plb-user{background:#B08D57;color:#fff;align-self:flex-end;border-bottom-right-radius:4px}\
.plb-msg a{color:#8a6a3a;font-weight:600;text-decoration:underline}\
.plb-user a{color:#fff}\
#plb-inputrow{display:flex;border-top:1px solid #EDE6D9;padding:10px;gap:8px;background:#fff}\
#plb-input{flex:1;border:1px solid #EDE6D9;border-radius:20px;padding:10px 14px;font-size:14px;outline:none}\
#plb-send{background:#B08D57;color:#fff;border:none;border-radius:50%;width:38px;height:38px;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center}\
#plb-escalate{display:none;flex-direction:column;gap:8px;padding:12px;border-top:1px solid #EDE6D9;background:#fff}\
#plb-escalate input{border:1px solid #EDE6D9;border-radius:8px;padding:9px 11px;font-size:13px}\
#plb-escalate button{background:#2b2b2b;color:#fff;border:none;border-radius:8px;padding:9px;font-size:13px;cursor:pointer}\
.plb-typing{align-self:flex-start;background:#fff;border:1px solid #EDE6D9;border-radius:14px;padding:10px 14px;display:flex;gap:4px}\
.plb-typing span{width:6px;height:6px;border-radius:50%;background:#B08D57;animation:plb-bounce 1.2s infinite}\
.plb-typing span:nth-child(2){animation-delay:.2s}.plb-typing span:nth-child(3){animation-delay:.4s}\
@keyframes plb-bounce{0%,60%,100%{transform:translateY(0)}30%{transform:translateY(-4px)}}\
";

  var style = document.createElement("style");
  style.textContent = CSS;
  document.head.appendChild(style);

  var bubble = document.createElement("button");
  bubble.id = "plb-bubble";
  bubble.setAttribute("aria-label", "Open chat support");
  bubble.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';
  document.body.appendChild(bubble);

  var win = document.createElement("div");
  win.id = "plb-window";
  win.innerHTML =
    '<div id="plb-header"><div><div id="plb-header-title">PawandLuna Support</div><div id="plb-header-sub">Usually replies instantly</div></div><button id="plb-close" aria-label="Close chat">\u00d7</button></div>' +
    '<div id="plb-messages"></div>' +
    '<div id="plb-escalate">' +
      '<div style="font-size:13px;color:#555;margin-bottom:2px">Didn\'t find your answer? Leave your info and we\'ll personally follow up:</div>' +
      '<input id="plb-esc-email" type="email" placeholder="Your email" />' +
      '<input id="plb-esc-msg" type="text" placeholder="Your question" />' +
      '<button id="plb-esc-send">Send to a real human</button>' +
    '</div>' +
    '<div id="plb-inputrow"><input id="plb-input" type="text" placeholder="Ask about shipping, returns, products\u2026" /><button id="plb-send" aria-label="Send">\u2192</button></div>';
  document.body.appendChild(win);

  var messagesEl = document.getElementById("plb-messages");
  var inputEl = document.getElementById("plb-input");
  var escalateEl = document.getElementById("plb-escalate");

  function addMsg(text, who, link, linkText) {
    var div = document.createElement("div");
    div.className = "plb-msg " + (who === "user" ? "plb-user" : "plb-bot");
    div.innerHTML = text.replace(/</g, "&lt;");
    if (link) {
      var a = document.createElement("a");
      a.href = link;
      a.textContent = linkText || "View";
      a.style.display = "block";
      a.style.marginTop = "6px";
      div.appendChild(a);
    }
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showTyping() {
    var t = document.createElement("div");
    t.className = "plb-typing";
    t.id = "plb-typing-indicator";
    t.innerHTML = "<span></span><span></span><span></span>";
    messagesEl.appendChild(t);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }
  function hideTyping() {
    var t = document.getElementById("plb-typing-indicator");
    if (t) t.remove();
  }

  var opened = false;
  bubble.addEventListener("click", function () {
    win.classList.toggle("plb-open");
    if (!opened) {
      opened = true;
      addMsg("Hi! I'm the PawandLuna support bot. Ask me about shipping, returns, or any of our products \u2014 I'll do my best, and if I can't answer, I'll connect you with a real person.", "bot");
    }
  });
  document.getElementById("plb-close").addEventListener("click", function () {
    win.classList.remove("plb-open");
  });

  function handleSend() {
    var text = inputEl.value.trim();
    if (!text) return;
    addMsg(text, "user");
    inputEl.value = "";
    showTyping();
    setTimeout(function () {
      hideTyping();
      var result = window.PawLunaBot ? window.PawLunaBot.answerFor(text) : null;
      if (result) {
        addMsg(result.text, "bot", result.link, result.linkText);
        escalateEl.style.display = "none";
      } else {
        addMsg("I'm not confident I can answer that correctly \u2014 let me connect you with a real person instead.", "bot");
        escalateEl.style.display = "flex";
      }
    }, 600);
  }

  document.getElementById("plb-send").addEventListener("click", handleSend);
  inputEl.addEventListener("keydown", function (e) {
    if (e.key === "Enter") handleSend();
  });

  document.getElementById("plb-esc-send").addEventListener("click", function () {
    var email = document.getElementById("plb-esc-email").value.trim();
    var msg = document.getElementById("plb-esc-msg").value.trim();
    if (!email || !msg) {
      addMsg("Please fill in both your email and question.", "bot");
      return;
    }
    var body = new URLSearchParams();
    body.append("form_type", "contact");
    body.append("utf8", "\u2713");
    body.append("contact[name]", "Website Chat Visitor");
    body.append("contact[email]", email);
    body.append("contact[body]", "[Chat bot escalation] " + msg);

    fetch("/contact", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString()
    }).then(function () {
      addMsg("Thanks! We've got your message and will email you back soon.", "bot");
      escalateEl.style.display = "none";
    }).catch(function () {
      addMsg("Something went wrong sending that \u2014 please email us directly at " + (window.PawLunaBot ? window.PawLunaBot.KB.contactEmail : "our support email") + ".", "bot");
    });
  });
})();
